module.exports = __webpack_public_path__ + "img/145.2b3f5432.jpg";